module.exports = __webpack_public_path__ + "img/4.cd665370.png";